import { useQuery } from '@tanstack/react-query'
import { ContactItemType } from '../../types'
import APIClient from '../../apiClient'
import { showAlertModal } from '../../store/modals'

export const useContactGroupListQuery = <T = ContactItemType[]>(search = '', type = 'contacts') => {
  return useQuery<unknown, unknown, T>({
    queryKey: [type, search],
    queryFn: async () => {
      if (search) {
        const res = await APIClient.contactSearch({ search })
        return res.data[type]
      }
      const res = await APIClient.contactList()
      return res.data
    },
    cacheTime: 1000 * 60 * 15 // 15 minutes
  })
}
